import React from 'react'

// third party components

// images and icons
import ShareSmallIcon from 'assets/icons/share-black-menu.svg?component'
import HideIcon from 'assets/icons/hide-icon-19x14.svg?component'
import UnsaveIcon from 'assets/icons/unsave-icon-12x16.svg?component'
import UnhideIcon from 'assets/icons/unhide-icon-19x14.svg?component'

// styles
import styles from './index.module.scss'

interface NftCardMenuPageProps {
  cardType: string
  shareArtwork: any
  hideArtwork: any
  unhideArtwork: any
  unSave: any
  isOwn: boolean
  isOnlyShare?: boolean
}

const NftCardMenuPage = ({
  shareArtwork,
  isOwn,
  hideArtwork,
  unhideArtwork,
  unSave,
  cardType,
  isOnlyShare = true,
}: NftCardMenuPageProps) => {
  return (
    <div className={styles.nftMenu}>
      <div
        className={`${styles.menuItem}`}
        onClick={() => {
          shareArtwork()
        }}
      >
        <div className="flex gap-[15px] items-center">
          <div className={styles.itemIcon}>
            <ShareSmallIcon alt="" />
          </div>
          <div>
            <div className={styles.itemTitle}>Share Artwork</div>
            <div className={styles.itemDescription}>Share to socials or copy link</div>
          </div>
        </div>
      </div>
      {isOwn && (
        <>
          {cardType === 'artwork' && !isOnlyShare && (
            <div>
              <div className={styles.separator} />
              <div
                className={`${styles.menuLastItem}`}
                onClick={() => {
                  hideArtwork()
                }}
              >
                <div className="flex gap-[15px] items-center">
                  <div className={styles.itemIcon}>
                    <HideIcon alt="" />
                  </div>
                  <div>
                    <div className={styles.itemTitle}>Hide Artwork</div>
                    <div className={styles.itemDescription}>Hide from my profile page</div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {cardType === 'favorites' && (
            <div>
              <div className={styles.separator} />
              <div
                className={`${styles.menuLastItem}`}
                onClick={() => {
                  unSave()
                }}
              >
                <div className="flex gap-[15px] items-center">
                  <div className={styles.itemIcon}>
                    <UnsaveIcon alt="" />
                  </div>
                  <div>
                    <div className={styles.itemTitle}>Unsave</div>
                    <div className={styles.itemDescription}>Remove from my favorites</div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {cardType === 'hidden' && (
            <div>
              <div className={styles.separator} />
              <div
                className={`${styles.menuLastItem}`}
                onClick={() => {
                  unhideArtwork()
                }}
              >
                <div className="flex gap-[15px] items-center">
                  <div className={styles.itemIcon}>
                    <UnhideIcon alt="" />
                  </div>
                  <div>
                    <div className={styles.itemTitle}>Unhide Artwork</div>
                    <div className={styles.itemDescription}>Display on my profile page</div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default NftCardMenuPage
